/** Well behind PDF pages in the import wizard canvas (steps 1–3). */
export const PDF_IMPORT_CANVAS_BACKGROUND = '#F7F5F1';
/**
 * Gutter between stacked pages in the continuous viewer — also used as the
 * left/right inset around each page so side margins match the stack gap.
 */
export const PDF_IMPORT_PAGE_STACK_GAP_PX = 34;
/** Max width of a rendered page in the continuous step-1 viewer. */
export const PDF_IMPORT_PAGE_MAX_WIDTH_PX = 820;
